import { APP_INITIALIZER, ApplicationConfig, ErrorHandler, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import * as Sentry from "@sentry/angular";

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { TranslocoHttpLoader } from './transloco-loader';
import { provideTransloco } from '@jsverse/transloco';
import { environment } from '../environments/environment';
import { tokenInterceptor } from './core/interceptors/token.interceptor';
import { sessionInterceptor } from './core/interceptors/session.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { IMAGE_CONFIG } from '@angular/common';
import { mfaRequiredInterceptor } from './core/interceptors/mfa-required.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes),

  //Sentry Angular SDK's ErrorHandler and Tracing providers
  {
    provide: ErrorHandler,
    useValue: Sentry.createErrorHandler(),
  },
  {
    provide: Sentry.TraceService,
    deps: [Router],
  },
  {
    provide: APP_INITIALIZER,
    useFactory: () => () => { },
    deps: [Sentry.TraceService],
    multi: true,
  },

  provideHttpClient(withInterceptors([tokenInterceptor, sessionInterceptor, mfaRequiredInterceptor])),

  provideTransloco({
    config: {
      availableLangs: ['en', 'it'],
      defaultLang: 'en',
      // Remove this option if application doesn't support changing language in runtime.
      reRenderOnLangChange: true,
      prodMode: environment.production,
    },
    loader: TranslocoHttpLoader
  }),

  provideAnimations(),

  {
    provide: IMAGE_CONFIG,
    useValue: {
      disableImageSizeWarning: true,
      disableImageLazyLoadWarning: true
    }
  },
  { provide: LOCALE_ID, useValue: 'it-IT' },
  ]
};
